import React from "react";
import wh1 from '../assets/wh 1.jpg';
import { ImTarget } from "react-icons/im";
import { useTranslation } from 'react-i18next';

const Ourvision = () => {
    const { t } = useTranslation();

    return (
        <div className="container-fluid p-0">
            {/* Header */}
            <div className="container-fluid text-white py-4  " style={{ backgroundColor: "rgba(9, 26, 58, 1)" }}>
                <div className="container text-start px-5 d-flex flex-column justify-content-start align-items-start">
                    <h5 className="fw-semibold mb-1"> {t('visionTitle')}</h5>
                    <hr className="border-white opacity-100 " style={{ width: "220px" }} />
                </div>
            </div>




            {/* Content */}
            <div className="container py-5"
            >
                <div className="row align-items-center">
                    {/* Left Content */}
                    <div className="col-lg-8" data-aos="fade-right">
                        <h5 className="text-primary text-center fw-bold mb-4">
                            <ImTarget className="me-2" />
                            "{t('visionQuote')}"
                        </h5>

                        <ul className="list-unstyled fs-6">
                            <li className="mb-3">• {t('visionPoint1')}</li>
                            <li className="mb-3">• {t('visionPoint2')}</li>
                            <li className="mb-3">• {t('visionPoint3')}</li>
                            <li className="mb-3">• {t('visionPoint4')}</li>
                        </ul>
                    </div>

                    {/* Right Illustration */}
                    <div className="col-lg-4 text-center">
                        <img
                            src={wh1}
                            alt="Vision Illustration"
                            className="img-fluid"
                            data-aos="zoom-in"
                            data-aos-delay="300"
                        />
                    </div>
                </div>
            </div>

            {/* <div className=" text-danger py-4 px-5">
                <hr className="w-100 opacity-100"  style={{borderColor: "rgba(9, 26, 58, 1)" }}/>
            </div> */}
        </div>
    );
};

export default Ourvision;
